const TZ = "Asia/Manila";

export const peso = (centavos: number | null | undefined) =>
  centavos == null ? "—" : new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP" }).format(centavos / 100);

export const dateTime = (iso?: string | null) =>
  iso ? new Intl.DateTimeFormat("en-PH", { timeZone: TZ, dateStyle: "medium", timeStyle: "short" }).format(new Date(iso)) : "—";

export const timeOnly = (iso?: string | null) =>
  iso ? new Intl.DateTimeFormat("en-PH", { timeZone: TZ, timeStyle: "short" }).format(new Date(iso)) : "—";

export const phone = (p?: string | null) => {
  if (!p) return "—";
  const m = p.match(/^\+63(\d{3})(\d{3})(\d{4})$/);
  return m ? `+63 ${m[1]} ${m[2]} ${m[3]}` : p;
};

export const ago = (iso?: string | null) => {
  if (!iso) return "";
  const s = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const kmBetween = (a?: { lat: number; lng: number } | null, b?: { lat: number; lng: number } | null) => {
  if (!a || !b) return null;
  const r = 6371, rad = (x: number) => (x * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat), dLng = rad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * r * Math.asin(Math.sqrt(h));
};

export const PRIORITY: Record<number, { label: string; cls: string }> = {
  1: { label: "P1 Critical", cls: "bg-[#FFC400] text-[#003F32]" },
  2: { label: "P2 Urgent", cls: "bg-amber-400 text-slate-900" },
  3: { label: "P3 Standard", cls: "bg-emerald-100 text-emerald-900" },
  4: { label: "P4 Scheduled", cls: "bg-slate-100 text-slate-700" },
};
